document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 1024) { // 只在手機版執行
      // 定義各語言對應的按鈕文字
      const buyNowText = {
        en: "Buy Now",
        zh: "立即購買",
        ja: "今すぐ購入"
      };
  
      // 取得網頁語言，預設為英文
      let lang = document.documentElement.lang || "en";
      lang = lang.substr(0, 2).toLowerCase();
      let btnText = buyNowText[lang] ? buyNowText[lang] : buyNowText["en"];
  
      console.log("當前語言：", lang, "，按鈕文字：", btnText);
  
      // 定義不同頁面對應的購買連結（皆以英文格式定義）
      const buyNowLinks = {
        "/pages/hikaru-v60-smart-brewer": "/products/hikaru-black",
        "/pages/jimmy": "/products/jimmy",
        "/pages/samantha": "/products/samantha",
        "/pages/samantha-ii": "/products/samantha-ii",
        "/pages/產品": "/products/產品商品" // 中文頁面範例
      };
  
      // 找到所有 slide-image 連結
      let slideLinks = document.querySelectorAll("a.slide-image");
      console.log("找到的 slide-image 連結數量：", slideLinks.length);
  
      slideLinks.forEach(function (link) {
        let href = link.getAttribute("href");
        console.log("檢查連結 href：", href);
  
        // 處理 full URL 與相對路徑的情況，提取 pathname
        let normalizedHref = "";
        try {
          let urlObj = new URL(href);
          // 取出 pathname 並移除 /語言碼
          normalizedHref = urlObj.pathname.replace(`/${lang}`, "");
        } catch (e) {
          // 如果 href 為相對路徑，直接處理
          normalizedHref = href.replace(`/${lang}`, "");
        }
        console.log("正規化後的 href：", normalizedHref);
  
        if (buyNowLinks[normalizedHref]) {
          let buyNowButton = document.createElement("a");
          let productLink = buyNowLinks[normalizedHref]; // 預設為英文連結格式
  
          // 當語言為日文且是 Hikaru 頁面時，直接指向指定 URL
          if (lang === "ja" && normalizedHref === "/pages/hikaru-v60-smart-brewer") {
            productLink = "https://shop.softbankselection.jp/?_gl=1*10lsnj7*_ga*MTc2ODQ1NjEzNC4xNzM0Njc0NTkz*_ga_4MD1NXTN7F*MTczNzAwMTcxNi4yLjEuMTczNzAwMTc2Ny4wLjAuMA";
          } else if (lang !== "en") {
            // 非英文頁面則在連結前加入語言碼
            productLink = `/${lang}${productLink}`;
          }
          buyNowButton.href = productLink; // 設定對應的商品購買頁面
          buyNowButton.className = "buy-now-btn";
          buyNowButton.innerText = btnText; // 根據語言設定按鈕文字
  
          // 找到圖片的父層
          let parentContainer = link.closest(".adaptive_height"); // 此 class 包住圖片
          if (parentContainer) {
            parentContainer.style.position = "relative"; // 確保父容器為相對定位
            parentContainer.appendChild(buyNowButton);
            console.log("已加入按鈕到：", parentContainer, "連結：", buyNowButton.href);
          } else {
            console.warn("找不到 .adaptive_height 父層，無法加入按鈕。");
          }
        } else {
          console.warn("找不到對應的連結：", normalizedHref);
        }
      });
    }
  });
  
  // 加入 CSS 讓按鈕位於圖片下方 85% 的位置，並改為曜石黑設計
  let style = document.createElement('style');
  style.innerHTML = `
    .buy-now-btn {
      position: absolute;
      top: 85%; /* 按鈕位於圖片 85% 高度 */
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(135deg, #111111 0%, #1C1C1C 100%);
      color: white;
      font-size: 16px;
      padding: 12px 24px;
      border-radius: 50px;
      font-weight: bold;
      text-decoration: none;
      text-align: center;
      z-index: 10;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
      transition: all 0.3s ease-in-out;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 140px;
      max-width: 180px;
    }
    
    .buy-now-btn:hover {
      background: linear-gradient(135deg, #222222 0%, #2C2C2C 100%);
      transform: translate(-50%, -50%) scale(1.05);
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.5);
    }
  
    @media screen and (min-width: 1024px) {
      .buy-now-btn {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);